import { ConfigType } from "./interface"

/**
 * x轴刻度生成函数
 * @param opt option配置项
 * @param config
 * @returns
 */
export const xAxisIntervalFormat = (opt, config: ConfigType = {}) => {
  // 刻度处理
  opt.xAxis[0].axisLabel.formatter = function (value) {
    return config.formatter ? config.formatter(value) : value
  }
  const xAxisData = opt?.xAxis[0]?.data
  const count = xAxisData.length;
  const defaultInterval = parseInt(((count - 1) / 24).toString());
  let differNum = count - defaultInterval * 24 - 1;
  let preIndex = 0
  const intervalFormat = (index) => {
    // 小于等于24个点全部展示
    if (count <= 24) {
      return true
    }
    if (index === count - 1) {
      // 遍历完数据重置（防止数据被刷掉）
      differNum = count - defaultInterval * 24 - 1;
      preIndex = 0
      return true
    }
    if (index === 0) {
      return true
    }
    // 间隔数
    let currentInterval = differNum > 0 ? defaultInterval : defaultInterval - 1
    if (preIndex + 1 + currentInterval === index) {
      differNum = differNum > 0 ? differNum - 1 : 0
      preIndex = index;
      return true
    }
    return false
  }
  opt.xAxis[0].axisLabel.interval = intervalFormat
  opt.xAxis[0].axisTick.interval = intervalFormat;
  // realtime 5分钟时间滑块刻度自适应事件
  const _chart = config?.chart || null
  if (_chart) {
    _chart.on('datazoom', (params: any) => {
      if (params?.start === 0 && params?.end === 100) {
        opt.xAxis[0].axisLabel.interval = intervalFormat
        opt.xAxis[0].axisTick.interval = intervalFormat;
        _chart.setOption(opt)
      } else {
        opt.xAxis[0].axisLabel.interval = 'auto'
        opt.xAxis[0].axisTick.interval = 'auto';
        _chart.setOption(opt)
      }
    })
  }
  return opt
}



/**
 * x轴高亮显示刻度
 * @param opt option配置项
 * @param config isRealtime 是否realTime折线图
 * @returns
 */
export const xAxisHighLight = (opt, config: ConfigType = { isRealtime: false }) => {
  if (!config?.isRealtime) {
    opt.series = opt.series?.map((seriesItem: any, seriesIndex: any) => {
      if (seriesItem?.type === 'line') {
        const seriesData = seriesItem?.data?.map((item: any, index: any) => {
          if (typeof item === 'object') return item
          // 是否是单独的圆点
          const isAloneSymbol = (seriesItem?.data[index - 1] === '' || seriesItem?.data[index - 1] === undefined) &&
            (seriesItem?.data[index + 1] === '' || seriesItem?.data[index + 1] === undefined)
          return {
            value: item,
            itemStyle: {
              opacity: isAloneSymbol ? 1 : 0
            },
            symbol: 'circle'
          }
        })
        return {
          ...seriesItem,
          data: seriesData,
          symbolSize: 8,
          emphasis: {
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1,
              borderType: 'solid',
              opacity: 1
            },
          }
        }
      } else {
        return seriesItem
      }
    })
  }

  opt.tooltip.axisPointer = {
    z: 0,
    label: {
      show: true,
      // backgroundColor: 'transparent',
      backgroundColor: '#ffffff',
      fontSize: 12,
      color: '#262832',
      fontWeight: 700,
      formatter: (params) => {
        return config.formatter ? config.formatter(params) : params.value
      }
    },
    lineStyle: config?.lineStyle || {
      color: '#cccccc',
      width: 1,
      type: 'solid'
    },
  }
  return opt
}